import React from 'react';
import { VideoPlayer } from '../components/VideoPlayer';
import { useMedia } from '../lib/media';

export function MediaPage() {
  const { items, loading } = useMedia();

  return (
    <section className="panel muted inner-page">
      <div className="panel-header">
        <p className="eyebrow">Live & Studio</p>
        <h2>Watch & Listen</h2>
        <p className="lede">Recent performances and fan favorites, played with our own player.</p>
      </div>
      {loading ? (
        <p className="meta">Loading media…</p>
      ) : items.length === 0 ? (
        <p className="media-empty">Videos are on the way!</p>
      ) : (
        <div className="grid media-grid">
          {items.map((item) => (
            <article key={item.id} className="card media-card">
              {item.kind === 'image' ? (
                <img className="media-photo" src={item.src} alt={item.title} />
              ) : (
                <VideoPlayer src={item.src} title={item.title} poster={item.poster || undefined} />
              )}
              <div className="media-meta">
                {item.label && <p className="eyebrow">{item.label}</p>}
                <h3>{item.title}</h3>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
